<template>
  <div class="page-wrap p-3">
    <div class="page-header p-3 mb-3 mt-3">
      <h3>Сверка актов</h3>
      <div class="add-item-block mt-3 mb-3 d-flex justify-content-end"
           v-if="isAdmin()">
        <b-button variant="success" @click="onClickAdd()">
          Добавить БИН
        </b-button>
      </div>
      <div class="filters">
        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="bin" class="form-label col-md-3"></label>
            <div class="col-md-9">
              <div class="input-group">
                <input class="form-control" type="text" placeholder="Поиск по БИН/Номер акта"
                       id="bin"
                       v-model="page.filter.search"
                       style="font-style: italic;">
                <button class="btn btn-primary" type="button" @click="reloadList()">
                  Найти
                </button>
              </div>
            </div>
          </div>
        </div>

        <div v-if="isAdmin() || isManagerFC() || isAdminReadOnly()">
          <div class="row col-md-9">
            <div class="el-input-group">
              <label for="trancheYear" class="form-label col-md-3">
                Год
              </label>
              <div class="col-md-9">
                <select v-model="page.filter.trancheYear" id="trancheYear"
                        v-on:change="reloadList()"
                        class="form-select">
                  <option v-for="(year, index) in trancheYears" :key="index" :value="year">
                    {{ year }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="row col-md-9">
            <div class="el-input-group">
              <label for="trancheNumber" class="form-label col-md-3">
                Номер транша
              </label>
              <div class="col-md-9">
                <select v-model="page.filter.trancheNumber" id="trancheNumber"
                        v-on:change="reloadList()"
                        class="form-select">
                  <option v-for="(trancheNumber, index) in trancheNumbers" :key="index" :value="trancheNumber">
                    {{ trancheNumber }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="row col-md-9">
            <div class="el-input-group">
              <label for="university" class="form-label col-md-3">
                ВУЗ
              </label>
              <div class="col-md-9">
                <multiselect
                    v-model="page.filter.university"
                    :options="universities"
                    :searchable="true"
                    :closeOnSelect="true"
                    label="nameRu"
                    track-by="universityId"
                    :close-on-select="true"
                    :allow-empty="true"
                    placeholder="Выберите ВУЗ"
                    :multiple="false"
                    :clear-on-select="true"
                    @select="val => {
                      page.filter.universityId = val?.universityId || null;
                      reloadList();
                    }"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="status" class="form-label col-md-3">
              Статус сверки
            </label>
            <div class="col-md-9">
              <select v-model="page.filter.verificationStatus" id="status"
                      v-on:change="reloadList()"
                      class="form-select">
                <option v-for="statusKey in Object.keys(verificationStatus)" :key="statusKey" :value="statusKey">
                  {{ verificationStatus[statusKey] }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="page-content mt-3 mb-3">
    <div class="page-content-info d-flex align-items-center justify-content-end">
      <b-button variant="success"
                :disabled="items.length === 0"
                @click="onClickGenerateReport()">
        Экспортировать в MS Excel
      </b-button>
    </div>

    <div class="page-content-info d-flex align-items-center justify-content-between">
      <div>Найдено: <span>{{ totalCount }}</span></div>
    </div>

    <b-table striped hover
             :items="items"
             :fields="fields"
             responsive="sm"
             no-local-sorting
             show-sort-labels>
      <template #head(bin)="data">
        <div class="sortable-container none"
             @click="onSortChanged('bin')"
             :class="{'ascending': page.sort.bin === 'ASC', 'descending': page.sort.bin === 'DESC'}">
          БИН
        </div>
      </template>
      <template #head(universityName)="data">
        <div class="sortable-container none"
             @click="onSortChanged('universityName')"
             :class="{'ascending': page.sort.universityName === 'ASC', 'descending': page.sort.universityName === 'DESC'}">
          Название ВУЗа
        </div>
      </template>
      <template #head(reportType)="data">
        <div class="sortable-container none col-report-type-count"
             @click="onSortChanged('reportType')"
             :class="{'ascending': page.sort.reportType === 'ASC', 'descending': page.sort.reportType === 'DESC'}">
          Тип отчета
        </div>
      </template>
      <template #head(signedAmount)="data">
        <div class="sortable-container none"
             @click="onSortChanged('signedAmount')"
             :class="{'ascending': page.sort.signedAmount === 'ASC', 'descending': page.sort.signedAmount === 'DESC'}">
          Сумма подписанного расчета
        </div>
      </template>
      <template #head(actId)="data">
        <div class="actId sortable-container none"
             @click="onSortChanged('actId')"
             :class="{'ascending': page.sort.actId === 'ASC', 'descending': page.sort.actId === 'DESC'}">
          ID Акта
        </div>
      </template>
      <template #head(numberAct)="data">
        <div class="sortable-container none"
             @click="onSortChanged('numberAct')"
             :class="{'ascending': page.sort.numberAct === 'ASC', 'descending': page.sort.numberAct === 'DESC'}">
          Номер акта
        </div>
      </template>
      <template #head(verificationStatus)="data">
        <div class="sortable-container none"
             @click="onSortChanged('verificationStatus')"
             :class="{'ascending': page.sort.verificationStatus === 'ASC', 'descending': page.sort.verificationStatus === 'DESC'}">
          Статус сверки
        </div>
      </template>


      <template #cell(bin)="data">
        {{ data.item.report.university.bin }}
      </template>
      <template #cell(universityName)="data">
        {{ data.item.report.university.nameRu }}
      </template>
      <template #cell(reportType)="data">
        <div class="col-report-type-count">
          {{ reportType[data.item.report.reportType].nameRu }}
        </div>
      </template>
      <template #cell(signedAmount)="data">
        {{ data.item.signedAmount }}
      </template>
      <template #cell(actId)="data">
        <div class="input-group" v-if="data.item.verificationStatus !== VerificationStatusEnum.SUCCESSFUL">
          <input v-model="data.item.actId" name="inputActId" type="text" class="form-control inputActId" />
          <button @click="onClickRefreshStatus(data.item)"
                  :disabled="data.item.actId == null"
                  name="btnRefresh"
                  v-if="isAdmin() || isManagerFC()"
                  class="btn btn-outline-secondary">
            <font-awesome-icon icon="sync"/>
          </button>
        </div>
        <div class="input-group" v-if="data.item.verificationStatus === VerificationStatusEnum.SUCCESSFUL">
          {{ data.item.actId }}
        </div>
      </template>
      <template #cell(numberAct)="data">
        {{ data.item.numberAct }}
      </template>
      <template #cell(verificationStatus)="data">
        {{ getStatus(data.item.verificationStatus) }}
      </template>


    </b-table>
  </div>
  <div class="page-footer">
    <b-pagination
        v-model="page.partNumber"
        :total-rows="totalCount"
        :per-page="page.countInPage"
        v-on:click="reloadList"
        first-text="<<"
        last-text=">>"
        class="mt-3"
    ></b-pagination>
  </div>

  <!-- Modal component -->
  <b-modal v-model="showModal" title="Добавление БИН для сверки акта" @ok="submitForm">
    <form @submit.prevent="submitForm" class="mb-4">
      <div class="mb-3">
        <label for="trancheYear" class="form-label">
          Год
        </label>
        <select v-model="form.filter.trancheYear" id="trancheYear" required
                class="form-select">
          <option disabled value="">Выберите год</option> <!-- Placeholder -->
          <option v-for="(year, index) in trancheYears" :key="index" :value="year">
            {{ year }}
          </option>
        </select>
      </div>

      <div class="mb-3">
        <label for="trancheNumber" class="form-label">
          Номер транша
        </label>
        <select v-model="form.filter.trancheNumber" id="trancheNumber"
                class="form-select" required>
          <option disabled value="">Выберите номер транша</option> <!-- Placeholder -->
          <option v-for="(trancheNumber, index) in trancheNumbers" :key="index" :value="trancheNumber">
            {{ trancheNumber }}
          </option>
        </select>
      </div>

      <div class="mb-3">
        <label for="bins" class="form-label">
          БИНы ДО
          <span class="text-danger">*</span>
        </label>
        <textarea v-model="form.filter.binsText" id="bins" rows="5"
                  placeholder="Введите БИНы ДО (через запятую)"
                  class="form-control" required/>
      </div>
    </form>
  </b-modal>

  <vue-loading :active.sync="isLoading" :is-full-page="true"></vue-loading>
</template>

<script>

import {
  createActReconciliation,
  generateReport,
  getAllActReconciliations,
  refreshActReconciliation
} from "@/services/actService";
import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import {saveAs} from "@/assets/FileSaver.min.js";
import universityService from "@/services/universityService";
import {VerificationStatusEnum} from "@/enum/VerificationStatus";
import {TemplateTypeEnum} from "@/enum/TemplateTypeEnum";
import delegationService from "@/services/delegationService";
import settingsService from "@/services/settingsService";
import {ReportTypeEnum} from "@/enum/ReportTypeEnum";
import Multiselect from "vue-multiselect";

export default {
  computed: {
    VerificationStatusEnum() {
      return VerificationStatusEnum
    }
  },
  components: {
    Multiselect,
    VueLoading
  },
  data() {
    return {
      showModal: false,
      isLoading: false,
      form: {
        filter: {
          trancheYear: null,
          trancheNumber: null,
          universityId: null,
          bins: [],
          binsText: '',
        }
      },
      page: {
        filter: {
          trancheYear: null,
          trancheNumber: null,
          universityId: null,
          search: null,
          bins: null,
          verificationStatus: VerificationStatusEnum.ALL
        },
        sort: {},
        partNumber: 1,
        countInPage: 10,
      },
      totalCount: 0,
      trancheYears: Array.from({length: 7}, (v, i) => 2024 + i),
      trancheNumbers: Array.from({length: 4}, (v, i) => 1 + i),
      universities: [],
      fields: [
        {key: 'bin', label: 'БИН ВУЗа', sortable: true},
        {key: 'universityName', label: 'Название ВУЗа', sortable: true},
        {key: 'reportType', label: 'Тип отчета', sortable: true},
        {key: 'signedAmount', label: 'Сумма подписанного расчета', sortable: true},
        {key: 'actId', label: 'ID Акта', sortable: true},
        {key: 'numberAct', label: 'Номер акта', sortable: true},
        {key: 'verificationStatus', label: 'Статус сверки', sortable: true}
      ],
      items: [],
      verificationStatus: {
        ALL: 'Все',
        NONE: 'Сверка еще не проводилась',
        SUCCESSFUL: 'Успешно',
        INVALID_ACT_NUMBER: 'Некорректный номер акта',
        VERIFICATION_FAILED: 'Проверка не прошла',
        APPROVAL_REQUIRED: 'Требуется согласование на портале'
      },
      reportType: ReportTypeEnum
    };
  },
  methods: {
    init() {
      this.initSettings().then(response => {
        this.page.filter.trancheYear = this.setting.defaultTrancheYear;
        this.page.filter.trancheNumber = this.setting.defaultTrancheNumber;

        this.reloadList();
      });
    },
    onClickAdd() {
      this.showModal = true;
      this.form.filter.trancheYear = this.setting.defaultTrancheYear;
      this.form.filter.trancheNumber = this.setting.defaultTrancheNumber;
      this.form.bins = [];
      this.form.binsText = '';
    },
    async submitForm() {
      const binsArray = this.form.filter.binsText.split(',');
      this.form.filter.bins = binsArray.map(bin => bin.trim());

      this.isLoading = true;
      await createActReconciliation(this.form);
      this.isLoading = false;

      this.reloadList();
    },
    async onClickGenerateReport() {
      this.isLoading = true;
      const response = await generateReport(TemplateTypeEnum.ACT_RECONCILIATION_XLSX, this.page);
      const blob = new Blob([response.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
      saveAs(blob, "document.xlsx");
      this.isLoading = false;
    },
    async onClickRefreshStatus(item) {
      this.isLoading = true;
      const updatedItem = await refreshActReconciliation(item);
      Object.assign(item, updatedItem);
      this.isLoading = false;
    },
    async reloadList() {
      this.isLoading = true;
      const response = await getAllActReconciliations(this.page);
      this.items = response.list;
      this.totalCount = response.count;
      this.isLoading = false;
    },
    getStatus(status) {
      return this.verificationStatus[status] || 'Неизвестный статус';
    },
    onSortChanged(column) {
      this.page.sort = {
        ...this.page.sort,
        [column]: this.page.sort[column] === 'ASC' ? 'DESC' : 'ASC'
      };

      this.reloadList();
    },
    initUniversities() {
      const params = {
        partNumber: 1,
        countInPage: 0,
        filter: {}
      };
      universityService.getAll(params)
          .then(response => {
            this.universities = response.list.sort((a, b) => a.nameRu.localeCompare(b.nameRu));
          });
    },
    isAdmin() {
      return delegationService.isAdmin();
    },
    isAdminReadOnly() {
      return delegationService.isAdminReadOnly();
    },
    isManagerFC() {
      return delegationService.isManagerFC();
    },
    async initSettings() {
      this.setting = await settingsService.load();
    },
    isUniversityManager() {
      return delegationService.isUniversityManager();
    },
  },
  mounted() {
    this.initUniversities();

    this.init();
  }
};
</script>

<style scoped>
.filters {
  .row {
    padding-top: 5px;
  }
}

.ascending {
  background-image: url("../assets/asc.svg") !important;
}

.descending {
  background-image: url("../assets/desc.svg") !important;
}

.none {
  background-image: url("../assets/none.svg");
  margin-left: 10px !important;
}

.sortable-container {
  background-position: right calc(0.75rem / 2) center;
  background-repeat: no-repeat;
  background-size: 0.65em 1em;
  vertical-align: middle !important;
  margin-right: 10px !important;
  padding-right: 15px !important;
  cursor: pointer;
}

th div {
  width: 100% !important;
  display: grid !important;
}

</style>
